type Props = {
  logo: string
  label: string
}

const Logo = ({ logo, label }: Props) => {
  return (
    <div className="block w-6 h-6 min-w-[24px] min-h-[24px]">
      <img height="100%" width="100%" src={logo} alt={`img-${label}`} />
    </div>
  )
}

export default Logo
